module.exports = __webpack_public_path__ + "static/media/icon_business.24db7b8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_business.svg
// module id = 712
// module chunks = 0